import { render, staticRenderFns } from "./ChangerequestsTable.vue?vue&type=template&id=4d8b39a7&"
import script from "./ChangerequestsTable.vue?vue&type=script&lang=js&"
export * from "./ChangerequestsTable.vue?vue&type=script&lang=js&"
import style0 from "./ChangerequestsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports